/**
 * @private
 * @type {boolean}
 * Determines if the current execution environment is a Node.js process.
 * It checks for the existence of the global 'process' object and its specific
 * versioning properties (`process.versions.node`).
 */
export const isNodeEnvironment = typeof process !== 'undefined' && process.versions != null && process.versions.node != null;
//# sourceMappingURL=is-node.js.map